import type { Dispatch, ReactNode, SetStateAction } from "react";
import { IntakeMobileChromeSetterContext, type IntakeMobileChromeActions } from "./IntakeMobileChromeContext";

export function IntakeMobileChromeSetterProvider({
  value,
  children,
}: {
  value: Dispatch<SetStateAction<IntakeMobileChromeActions | null>>;
  children: ReactNode;
}) {
  return (
    <IntakeMobileChromeSetterContext.Provider value={value}>
      {children}
    </IntakeMobileChromeSetterContext.Provider>
  );
}

